import { render, staticRenderFns } from "./NavigationMenuBase.vue?vue&type=template&id=73c7b38c&"
import script from "./NavigationMenuBase.vue?vue&type=script&lang=js&"
export * from "./NavigationMenuBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports